export const getElementByIdOrFail = function (elementId) {
    const result = document.getElementById(elementId);
    if (result) {
        return result;
    }
    else {
        throw `Element ${elementId} was not found in the DOM`;
    }
};
export const showElementById = function (elementId, newDisplayValue) {
    const element = getElementByIdOrFail(elementId);
    showElement(element, newDisplayValue);
};
export const showElement = function (element, newDisplayValue) {
    if (element) {
        element.style.display = newDisplayValue ?? "block";
    }
    else {
        throw "The element to show was undefined";
    }
};
export const hideElementById = function (elementId) {
    const element = getElementByIdOrFail(elementId);
    hideElement(element);
};
export const hideElement = function (element) {
    if (element) {
        element.style.display = "none";
    }
    else {
        throw "The element to show was undefined";
    }
};
